import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_SUMMARY_ACTION_TYPE } from '../actions';

const initialState = {};

const loanSummaryReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_SUMMARY_ACTION_TYPE.GET_SUMMARY:
        draft.summary = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanSummaryReducer;
